<template>
  <div>
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog as="div" class="fixed inset-0 flex z-40 md:hidden" @close="sidebarOpen = false">
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-600/75" />
        </TransitionChild>
        <TransitionChild
          as="template"
          enter="transition ease-in-out duration-300 transform"
          enter-from="-translate-x-full"
          enter-to="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leave-from="translate-x-0"
          leave-to="-translate-x-full"
        >
          <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white">
            <TransitionChild
              as="template"
              enter="ease-in-out duration-300"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="ease-in-out duration-300"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <div class="absolute top-0 right-0 -mr-12 pt-2">
                <button
                  type="button"
                  class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-white"
                  @click="sidebarOpen = false"
                >
                  <span class="sr-only">{{ t("close_sidebar") }}</span>
                  <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </TransitionChild>
            <div class="shrink-0 flex items-center px-4">
              <img class="h-8 w-auto" src="@/assets/large_logo_estaly_black.png" alt="Estaly" />
            </div>
            <div class="mt-3 flex-1 h-0 overflow-y-auto">
              <InsurerMenu @close="sidebarOpen = false" />
            </div>
          </div>
        </TransitionChild>
        <div class="shrink-0 w-14" aria-hidden="true"></div>
      </Dialog>
    </TransitionRoot>

    <div class="hidden md:flex md:w-64 z-20 md:flex-col md:fixed md:inset-y-0">
      <div class="flex flex-col grow pt-5 overflow-hidden bg-white border-r border-gray-200">
        <div class="flex items-center shrink-0 px-4">
          <img class="h-6 w-auto" src="@/assets/large_logo_estaly_black.png" alt="Estaly" />
        </div>
        <div class="mt-3 flex-1 overflow-y-auto">
          <InsurerMenu />
        </div>
        <div class="shrink-0 border-t border-gray-200">
          <UserMenu
            menuItemsClass="z-50 absolute bottom-full left-0 mb-1 w-full rounded-md shadow-lg py-1 bg-white ring-1 ring-black/5 focus:outline-hidden"
          >
            <MenuButton
              class="w-full min-w-0 flex items-center px-4 py-3 text-left hover:bg-gray-100 group overflow-hidden"
            >
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-900 truncate">{{ currentUser.email }}</p>
              </div>
              <ChevronDownIcon class="h-4 w-4 text-gray-400 shrink-0 ml-2" />
            </MenuButton>
          </UserMenu>
        </div>
      </div>
    </div>
    <div class="md:pl-64 flex flex-col flex-1">
      <div class="md:hidden sticky top-0 z-30 shrink-0 flex h-16 bg-white shadow-sm">
        <button
          type="button"
          class="px-4 border-r border-gray-200 text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-inset focus:ring-primary md:hidden"
          @click="sidebarOpen = true"
        >
          <span class="sr-only">{{ t("open_sidebar") }}</span>
          <MenuAlt2Icon class="h-6 w-6" aria-hidden="true" />
        </button>
        <div class="flex-1 px-4 flex justify-end">
          <div class="ml-4 flex items-center md:ml-6">
            <UserMenu class="ml-3">
              <MenuButton class="max-w-xs bg-white flex items-center text-sm rounded-full">
                <span class="sr-only">{{ t("open_user_menu") }}</span>
                <div
                  class="h-10 w-10 rounded-full bg-primary-lighter hover:bg-primary flex items-center justify-center"
                >
                  <p class="text-white">{{ currentUserInitials }}</p>
                </div>
              </MenuButton>
            </UserMenu>
          </div>
        </div>
      </div>

      <div class="relative min-h-screen">
        <main>
          <div class="py-6">
            <div class="px-4">
              <router-view :key="$route.path"></router-view>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Dialog, DialogOverlay, MenuButton, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ChevronDownIcon, MenuAlt2Icon, XIcon } from "@heroicons/vue/outline";
import { mapState } from "vuex";
import InsurerMenu from "@/components/InsurerMenu.vue";
import UserMenu from "@/components/UserMenu.vue";

export default {
  components: {
    InsurerMenu,
    UserMenu,
    Dialog,
    DialogOverlay,
    MenuButton,
    TransitionChild,
    TransitionRoot,
    ChevronDownIcon,
    MenuAlt2Icon,
    XIcon,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  data: () => ({ sidebarOpen: false }),
  computed: {
    ...mapState("auth", ["currentUser"]),
    currentUserInitials() {
      return this.currentUser?.email ? this.currentUser.email.charAt(0).toUpperCase() : "";
    },
  },
};
</script>

<i18n src="./InsurerLayout.i18n.json"></i18n>
